import React from "react";
import { closeDialog, selectDialogOpen } from "../../../Redux/dialogSlice";
import UpgradeNowGlobal from "./UpgradeNowGlobal";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";

const PremiumPopupHandler = () => {
  const isOpen = useAppSelector(selectDialogOpen);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closeDialog());
  };

  return isOpen ? <UpgradeNowGlobal onClose={handleClose} /> : null;
};

export default PremiumPopupHandler;
